<template>
  <div id="myDateShow">
    <div class="title">{{coveShed.id?"修改":"新增"}} 心坞栈资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">心坞栈类型</div>
        <div class="value">
          <el-select class="w500" v-model="coveShed.coveShedClassify" placeholder="请选择心坞栈类型">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="key">心坞栈名称</div>
        <div class="value">
          <el-input class="w500" v-model="coveShed.coveShedName" placeholder="请填写心坞栈名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">联系人</div>
        <div class="value">
          <el-input class="w500" v-model="coveShed.coveShedUsername" placeholder="请填写心坞栈联系人名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">联系人手机号</div>
        <div class="value">
          <el-input class="w500" v-model="coveShed.coveShedPhone" placeholder="请填写心坞栈联系人手机号"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">常用邮箱</div>
        <div class="value">
          <el-input class="w500" v-model="coveShed.coveShedEmail" placeholder="请填写心坞栈联系人常用邮箱"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">联系地址</div>
        <div class="value">
          <el-input class="w500" v-model="coveShed.coveShedAddress" placeholder=" 请填写联系地址"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">营业时间</div>
        <div class="value">
          <el-input class="w500" v-model="coveShed.workTime" placeholder=" 请填写营业时间"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">心坞栈区域(市/区)</div>
        <div class="value">
          <select-input
                  @inputFocus="inputFocus"
                  :itemArr="cityArr"
                  :value="coveShed.coveShedCity"
                  @handleSelect="handleSelect"></select-input>
        </div>
      </div>
      <div class="line">
        <div class="key">心坞栈社区</div>
        <div class="value">
          <div class="tag" v-for="(item,index) in coveShed.coveShedAddresses">
            <span>{{item.labelTwoName}}</span>
            <i class="el-icon-circle-close" @click="delLabel(index)"></i>
          </div>
          <select-input
                  @inputFocus="inputFocusTwo"
                  :itemArr="cityArrTwo"
                  :value="coveShed.coveShedCityTwo"
                  @handleSelect="handleSelectTwo"></select-input>
        </div>
      </div>
      <div class="line">
        <div class="key">合作协议书</div>
        <div class="value">
          {{coveShed.agreementName}}
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-upload
                  :headers="headers"
                  ref="upload"
                  :on-change="upLoad"
                  :on-success="upLoadSeccess"
                  class="upload-demo"
                  name="multipartFile"
                  drag
                  :action="baseURL+'/coveShed/upload'"
                  :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">重新提交协议书</div>
          </el-upload>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getCoveShedById, newVue, updateCoveShed,getCoveShedAddressAll,getCoveShedAddressByCity} from "../../network/coveShed";
  import SelectInput from "../../components/common/selectInput/SelectInput";

  export default {
    name: "coveShedInsert",
    components:{SelectInput},
    data(){
      return{
        coveShed: {
          coveShedAddresses:[]
        },
        coveShedId: '',
        options: [
          {
            value:"自营心坞栈",
            label:"自营心坞栈"
          },
          {
            value:"联营心坞栈",
            label:"联营心坞栈"
          }
        ],
        //心坞栈区域集合
        cityArr:[],
        //心坞栈社区集合
        cityArrTwo:[],
        //显示的心坞栈区域
        authorization:"",
        headers: {
        },
        baseURL:newVue.baseURL
      }
    },
    created() {
      newVue.obj = this;
      this.authorization=newVue.obj.common.loginInfo.jwtToken;
      this.headers.Authorization = this.authorization;
      this.common.HeaderLocationTwo.href =  "/coveShed/list";
      this.common.HeaderLocationTwo.name = "心坞栈资料管理"
      this.common.HeaderLocationThree.name = "新增or修改心坞栈列表"
      if (this.$route.params.id!=null){
        this.coveShedId = this.$route.params.id;

        // 获取更新的心坞栈信息
        getCoveShedById(this.coveShedId).then(res => {
          this.coveShed = res.data;
          this.coveShed.coveShedCity = res.data.coveShedAddresses[0].labelName
        })
      }
    },
    methods: {
      delLabel(index) {
        this.coveShed.coveShedAddresses.splice(index, 1);
      },
      inputFocus(){
        if (this.cityArr.length<=0){
          // 获取心坞栈区域(市/区)列表
          getCoveShedAddressAll().then(res => {
            let i = 0;
            res.data.forEach(e => {
              let cityItem = {}
              cityItem.id = i
              cityItem.value = e
              this.cityArr.push(cityItem)
              i++
            })
          })
        }
      },
      inputFocusTwo(){
        if (this.cityArrTwo.length<=0){
          // 根据心坞栈区域来获取心坞栈社区列表
          getCoveShedAddressByCity(this.coveShed.coveShedCity).then(res => {
            let i = 0;
            res.data.forEach(e => {
              let cityItem = {}
              cityItem.id = e.id
              cityItem.value = e.labelTwoName
              this.cityArrTwo.push(cityItem)
              i++
            })
          })
        }
      },
      handleSelect(item){
        this.$set(this.coveShed,"coveShedCity",item.value);
        this.$set(this.coveShed,"coveShedCityTwo","");
        this.cityArrTwo = []
      },
      handleSelectTwo(item){
        // console.log(item)
        if (item.id==null){
          return
        }
        let coveShedAddressesItem = {}
        coveShedAddressesItem.id = item.id
        coveShedAddressesItem.labelName = this.coveShed.coveShedCity
        coveShedAddressesItem.labelTwoName = item.value
        this.coveShed.coveShedAddresses.push(coveShedAddressesItem)
        let a = item.id  < this.cityArrTwo.length-1 ? item.id : this.cityArrTwo.length-1;
        for (a; a >= 0; a--) {
          if (this.cityArrTwo[a].id === item.id) {
            this.cityArrTwo.splice(a, 1,"")
          }
        }
      },
      upLoadSeccess(res){
        this.coveShed.agreementUrl = res.data;
      },
      backClick(){
        this.$router.push("../list");
      },
      upLoad (file, fileList) {
        this.coveShed.agreementName = file.name.split(".")[0]
        this.$refs.upload.submit()
      },
      submit(){
        updateCoveShed(this.coveShed).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }

  .tag {
    display: inline-block;
    height: 30px;
    background-color: #67c23a;
    border-color: #e9e9eb;
    color: white;
    box-sizing: border-box;
    margin: 2px 6px 2px 0;
    padding: 0 8px;
    line-height: 30px;
  }

  .tag span {
    margin-right: 3px;
  }

  .tag i {

  }
</style>
